import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import MainUnits from "../components/units/MainUnits";

const UnitScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <MainUnits />
      </main>
    </>
  );
};

export default UnitScreen;
